'use client'

import { memo } from 'react'

import { DateItem } from './DateItem'

import styles from './DeliveryDateSelector.module.scss'

interface DeliveryDate {
  date: string
  dayOfWeek: string
  shortDate: string
}

interface DeliveryDateSelectorProps {
  dates: DeliveryDate[]
  selectedDate: string | null
  dateWithSelection: string | null
  onDateChange: (date: string) => void
}

/**
 * Component for selecting delivery dates
 * Displays a horizontal list of available delivery dates with selection state
 */
const DeliveryDateSelector: React.FC<DeliveryDateSelectorProps> = ({
  dates,
  selectedDate,
  dateWithSelection,
  onDateChange
}) => {
  return (
    <div className={styles.dateWrapper}>
      {dates.map(date => (
        <DateItem
          key={date.date}
          date={date}
          isActive={selectedDate === date.date}
          hasSelection={dateWithSelection === date.date}
          onClick={() => onDateChange(date.date)}
        />
      ))}
    </div>
  )
}

export default memo(DeliveryDateSelector)
